// 예약 화면 단계 기록(UX/UI 1팀 10/17): 손님이 어느 고르기에서 멈추는지 세려고, 고를 때마다 작은 그림 파일(/img/bs.gif)을 한 번 부른다.
// 서버 접속 기록(lafia-api-detail.log)에 주소가 남는다. 보내는 것은 단계 이름(s), 화면 종류(v), 예약 화면을 열 때마다 새로 만드는 무작위 번호(k)뿐이다(개인정보 없음).
// 세는 법: 웹개발팀 팀_UXUI 업무기록 20261017-1820-예약화면고치기\단계기록_SC01.js
let visit = ""

export function startBookingVisit() {
  visit = Math.random().toString(36).slice(2, 10)
}

export function markBookingStep(step, screen) {
  try {
    if (!visit) startBookingVisit()
    const image = new Image()
    image.src = `/img/bs.gif?s=${encodeURIComponent(step)}&v=${encodeURIComponent(screen || "")}&k=${visit}&t=${Date.now()}`
  } catch (error) {}
}
